import { t } from "@/i18n-js/instance";
import { planTiers } from "@/react/helpers/planHelpers";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { Typography } from "@circle-react-uikit/Typography";
import { BillingCurrency } from "../../RegularPlan/BillingCurrency";
import { usePlans } from "../../RegularPlan/PlansContext";

export const PlanSelectorTitle = () => {
  const { selectedPlan } = usePlans();
  const isEnterpriseSelected = selectedPlan?.tier === planTiers.enterprise;
  return (
    <div
      className={classNames(
        "border-primary flex items-center justify-between px-6 pb-5 pt-6",
        isEnterpriseSelected && "border-b",
      )}
    >
      <Typography.LabelXl weight="semibold" color="text-dark">
        {t(["pricing_plans.plan_settings.plan_selection", "title"])}
      </Typography.LabelXl>
      <BillingCurrency />
    </div>
  );
};
